import { Command, CommandHandler, ConsoleLogger, HttpService, RepositorySaveResponse, TaggedUrl, Tags } from '@skylab-shared/core';
import { FiscalizationState } from '@skylab-shared/dataModel';
import { ResponseUtils } from '@skylab-shared/utils';

export interface SaleUpdateFiscalizationStatusCommandParams {
	id: number,
	data: {
		value: FiscalizationState;
		printerNumber: string;
		ticketNumber: string;
	},
}

export class SaleUpdateFiscalizationStatusCommand extends Command<SaleUpdateFiscalizationStatusCommandParams, string | undefined> { }

export class SaleUpdateFiscalizationStatusCommandHandlerBase implements CommandHandler<SaleUpdateFiscalizationStatusCommand, SaleUpdateFiscalizationStatusCommandParams, string | undefined> {
	private logger = new ConsoleLogger(this.constructor.name);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync({ params }: SaleUpdateFiscalizationStatusCommand): Promise<string | undefined> {
        try {
            const response = await this.http.put(TaggedUrl.join(`sales/${params?.id}/fiscalizationState`, [Tags.Api, Tags.OmitMessage]), params?.data);
            if (ResponseUtils.isStatusSuccess(response.status)) {
                const successData: RepositorySaveResponse = response.data;
                return successData.object?.version;
            }
        } catch (err) {
            this.logger.error(err);
        }
        return undefined;
    }
}
